import { styled } from '../../style/theme/themeModule';

export const FieldDescription = styled.div`
  margin-top: 20px;
  color: ${(p) => p.theme.colors.primary4};
`;
